<app-page>
  <div top-right>
    <app-button [matMenuTriggerFor]="topRightMenu" class="mb-1" color="primary" icon="more_vert"></app-button>
    <mat-menu #topRightMenu="matMenu">
      <button (click)="onDeleteAllClick()" [disabled]="!canDeleteAll" mat-menu-item>
        <mat-icon class="text-red-700 material-symbols-outlined">delete_forever</mat-icon>
        <span class="text-red-700">Elimina tutti</span>
      </button>
    </mat-menu>
  </div>
  <div class="">
    <mat-stepper [linear]="true" #pageStepper class="surface-50" (selectionChange)="onStepChange($event)">
      <mat-step [stepControl]="prelievo" [formGroup]="prelievo" class="p-2">
        <div class="flex flex-column gap-2 p-3">
          <app-punti-campionamento-controlli-input-select name="uuid" [form]="prelievoForm" (datoSelectedInput)="chekDataSelectedd($event)"></app-punti-campionamento-controlli-input-select>
          <app-input-toggle name="controlloEsterno" [form]="prelievoForm" label="Controllo esterno"></app-input-toggle>
          <app-input-toggle name="controlloExtraPiano" [form]="prelievoForm" label="Controllo Extra Piano"></app-input-toggle>
        </div>
        <div class="flex flex-column md:flex-row gap-1 w-full justify-content-around">
          <span><strong>La data di Prelievo deve rientrare nel limite delle date di validità del punto di campionamento</strong></span>
        </div>
        <br>
        <div class="flex flex-column md:flex-row gap-1 w-full justify-content-around">
          <app-card title="Dati del prelievo" class="flex flex-column gap-1 md:w-5" borderless>
            <app-prelievo-form [form]="prelievo" [puntoCamp]="puntiCampDateValid"></app-prelievo-form>
          </app-card>
          <app-card title="Dati dell'analisi" class="flex flex-column gap-1 md:w-5" borderless>
            <app-analisi-form [form]="analisi"  [prelievoData]="prelievo"></app-analisi-form>
          </app-card>
        </div>
      </mat-step>
      <mat-step [stepControl]="controlliForm">
        <div class="step-container">
          <div class="header p-3">
            <div class="text-sm text-700 font-light">Inserisci nuova riga</div>
            <mat-divider></mat-divider>
            <app-dati-controllo-row-template [element]="newElement" class="p-1" [list]="parametri()">
              <div action>
                <app-button (click)="onAddClick()" [disabled]="!newElement.valid" icon="add_circle" color="primary" class="mb-1"></app-button>
              </div>
            </app-dati-controllo-row-template>
            <div class="flex justify-content-end p-2 mr-3">
              <div class="text-sm font-light">Hai inserito <span class="font-medium">{{controlli.length}}</span> controlli</div>
            </div>
            <div class="grid grid-nogutter text-sm font-medium uppercase hidden lg:flex">
              <div class="col">
                <div class="grid">
                  <div class="col-12  md:col-3 lg:col-3 p-1">
                    <span class="px-2">Parametro</span>
                  </div>
                  <div class="col-12  md:col-2 lg:col-2  p-1">
                    <span class="px-2">Informazioni</span>
                  </div>
                  <div class="col-12 md:col-3 lg:col-3 p-1">
                    <span class="px-2">Valore</span>
                  </div>
                  <div class="col-12  md:col-2 lg:col-2  p-1">
                    <span class="px-2">Incertezza</span>
                  </div>
                  <div class="col-12  md:col-2 lg:col-2  p-1">
                    <span class="px-2">Metodo</span>
                  </div>
                </div>
              </div>
              <div class="col-auto" style="min-width: 40px;">
              </div>
            </div>
            <mat-divider></mat-divider>
          </div>
          <div [formGroup]="controlliForm">
            <ng-container formArrayName="controlli">
              @for (element of controlli.controls; track trackByIndex; let i=$index) {
                <form [formGroup]="controlliForm" >
                  <app-dati-controllo-row-template [element]="element" [list]="parametri()" [ngClass]="{ 'bg-red-100' : !element.valid, 'bg-primary-50': element.valid && 0 === i % 2, 'bg-white': element.valid && 0 !== i % 2 }">
                    <div action>
                      <app-button icon="more_vert" color="primary" class="mb-1" [matMenuTriggerFor]="menu"></app-button>
                      <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="onDeleteClick(element.value, i)">
                          <mat-icon class="text-red-700 material-symbols-outlined">delete</mat-icon>
                          <span class="text-red-700">Elimina</span>
                        </button>
                      </mat-menu>
                    </div>
                  </app-dati-controllo-row-template>
                </form>
              } @empty {
                <app-empty-list name="controllo" hint="Utilizza la riga in alto per inserire nuovi controlli"></app-empty-list>
              }
            </ng-container>
          </div>
        </div>
      </mat-step>
    </mat-stepper>
  </div>
  <div footer class="p-2 w-full">
    <div class="flex justify-content-between w-full">
      <div class="px-2">
        <app-button matStepperPrevious *ngIf="canGoPreviousStep()" (click)="previousPageClick()" label="Indietro" icon="keyboard_arrow_left" [fullWidth]="false" classButton="text-700" />
      </div>
      <div class="px-2">
        <app-button matStepperNext [disabled]="!isValidForm" *ngIf="canGoNextStep()" (click)="nextPageClick()" label="Avanti" icon="keyboard_arrow_right" raised [fullWidth]="false" classButton="" />
        <app-button *ngIf="canShowSend()" (click)="onSendClick()" [disabled]="!canSend" label="Trasmetti" icon="send" raised [fullWidth]="false" classButton="" />
      </div>
    </div>
  </div>
</app-page>
